import {
  FileText, Megaphone, List, HelpCircle, Video,
  MessageSquare, Share2, Image,
} from 'lucide-react';
import type { ContentSectionConfig } from './types';

export const CONTENT_SECTIONS: ContentSectionConfig[] = [
  {
    type: 'ADVERTORIAL',
    label: 'Advertorial',
    icon: Megaphone,
    colorClass: 'text-accent-primary',
    bgClass: 'bg-accent-primary/10',
    borderClass: 'border-accent-primary/20',
  },
  {
    type: 'LISTICALE',
    label: 'Listical',
    icon: List,
    colorClass: 'text-accent-info',
    bgClass: 'bg-info/10',
    borderClass: 'border-info/20',
  },
  {
    type: 'QUIZ',
    label: 'Quiz',
    icon: HelpCircle,
    colorClass: 'text-accent-tertiary',
    bgClass: 'bg-accent-tertiary/10',
    borderClass: 'border-accent-tertiary/20',
  },
  {
    type: 'LANDING',
    label: 'Produktowe',
    icon: FileText,
    colorClass: 'text-accent-primary',
    bgClass: 'bg-accent-primary/10',
    borderClass: 'border-accent-primary/20',
  },
  {
    type: 'AD_COPY',
    label: 'Treści reklamowe',
    icon: MessageSquare,
    colorClass: 'text-accent-secondary',
    bgClass: 'bg-accent-secondary/10',
    borderClass: 'border-accent-secondary/20',
  },
  {
    type: 'VIDEO_SCRIPT',
    label: 'Reklamy wideo',
    icon: Video,
    colorClass: 'text-accent-info',
    bgClass: 'bg-info/10',
    borderClass: 'border-info/20',
  },
  {
    type: 'AD_GRAPHIC',
    label: 'Reklamy statyczne',
    icon: Image,
    colorClass: 'text-accent-tertiary',
    bgClass: 'bg-accent-tertiary/10',
    borderClass: 'border-accent-tertiary/20',
  },
  {
    type: 'UGC_SCRIPT',
    label: 'Skrypty UGC',
    icon: Video,
    colorClass: 'text-accent-info',
    bgClass: 'bg-info/10',
    borderClass: 'border-info/20',
  },
  {
    type: 'SOCIAL_POST',
    label: 'Social Media',
    icon: Share2,
    colorClass: 'text-accent-secondary',
    bgClass: 'bg-accent-secondary/10',
    borderClass: 'border-accent-secondary/20',
  },
];

export const RADAR_AXES = [
  { key: 'activeAds', label: 'Aktywne reklamy' },
  { key: 'adDuration', label: 'Emisja reklam' },
  { key: 'formatVariety', label: 'Formaty' },
  { key: 'newCreatives', label: 'Nowe kreacje' },
  { key: 'platformReach', label: 'Platformy' },
  { key: 'engagement', label: 'Engagement' },
  { key: 'budget', label: 'Budżet' },
] as const;

export const SUPPLIER_TYPE_LABELS: Record<string, string> = {
  MARKETPLACE: 'Marketplace',
  WHOLESALER: 'Hurtownia',
  PRODUCER: 'Producent',
  DROPSHIPPING: 'Dropshipping',
};

export const CONTENT_ROUTE_MAP: Record<string, string> = {
  LANDING: 'landings',
  ADVERTORIAL: 'advertoriales',
  LISTICALE: 'listicales',
  QUIZ: 'quizy',
};

export function getStatusLabel(status: string): string {
  const map: Record<string, string> = {
    DRAFT: 'Szkic',
    INPUT: 'Dane uzupełnione',
    ANALYZING: 'Analizowanie...',
    KNOWLEDGE_READY: 'Baza wiedzy gotowa',
    GENERATING: 'Generowanie...',
    COMPLETE: 'Kompletny',
  };
  return map[status] || status;
}

export function getStatusColor(status: string): string {
  if (['COMPLETE', 'KNOWLEDGE_READY'].includes(status)) return 'text-success';
  if (['ANALYZING', 'GENERATING'].includes(status)) return 'text-warning';
  return 'text-gray-300';
}

export function getContentStatusBadge(status: string) {
  if (status === 'COMPLETE') return { label: 'Gotowy', bg: 'bg-success/10', text: 'text-success' };
  if (status === 'GENERATING') return { label: 'Generowanie...', bg: 'bg-warning/10', text: 'text-warning' };
  return { label: 'Szkic', bg: 'bg-gray-500/15', text: 'text-gray-300' };
}
